import Container from './FolderHeaderDesktop.container';
import FolderHeaderDesktop from './FolderHeaderDesktop';

export default Container(FolderHeaderDesktop);
